/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Same_TypeInputs */

const en_sch_err_same_type = /** @type {(inputs: Sch_Err_Same_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a different type to move the items to.`)
};

const de_sch_err_same_type = /** @type {(inputs: Sch_Err_Same_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle einen anderen Typ als Ziel.`)
};

/**
* | output |
* | --- |
* | "Choose a different type to move the items to." |
*
* @param {Sch_Err_Same_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_same_type = /** @type {((inputs?: Sch_Err_Same_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Same_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_same_type(inputs)
	return en_sch_err_same_type(inputs)
});